export default class Overview {
  constructor() {
    this.tasks_opened = 0,
    this.tasks_closed = 0,
    this.todos_opened = 0,
    this.todos_closed = 0,
    this.task_assignments = 0,
    this.task_assignments_closed = 0
  }
}
